module.exports = __webpack_public_path__ + "static/media/Transilluminator.180515f5.svg";